import {
  SelectAdvanceComponents,
  Typography,
  Box,
  Chip,
  Tooltip,
  Avatar,
} from '@applift/factor'
import { Row } from '@tanstack/react-table'
import { CurrencyDollar, SemanticWarning, InfoCircle } from '@applift/icons'
import { PrebidNormalizedSegmentData } from '../../models/PreBidAudience'

export const ListItemRenderer =
  SelectAdvanceComponents.DefaultListOptionItemWrapper<PrebidNormalizedSegmentData>(
    {
      disableCheckbox: true,
      checkboxLikeSelectionForItem: false,
      disableParentChildSelection: true,
    }
  )

export const renderOption = (
  row: Row<PrebidNormalizedSegmentData>,
  showWarning: boolean,
  warningText: string
) => {
  if (row.original.isProvider) {
    return (
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <Box sx={{ pr: 8, py: 8 }}>
          <Avatar
            size={32}
            variant="square"
            src={row.original.providerLogoUrl as string}
            alt={row.original.providerName}
            imgProps={{
              style: { objectFit: 'cover' },
            }}
          />
        </Box>
        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
          <Typography>{row.original.label}</Typography>
          <Typography variant="label" sx={{ textColor: 'neutral-500' }}>
            {row.original.description}
          </Typography>
        </Box>
      </Box>
    )
  }

  const isImmediateParentOfLeafNode = Array.isArray(row.subRows)
    ? row.subRows.some(item => item.original.isLeaf === true)
    : false

  const isAllCreativeTypeSection = Array.isArray(row.subRows)
    ? row.subRows.every(item => item.original.isAllCreativeType === true)
    : false

  if (isImmediateParentOfLeafNode) {
    const cpmToDisplay = Math.max(...row.original.subRows.map(obj => obj.cpm))
    const atleastOneChildSelected =
      row.getIsSomeSelected() || row.getIsAllSubRowsSelected()
    return (
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 4 }}>
        <Typography>{row.original.label}</Typography>
        <Chip
          label={
            <Typography weight="normal">{`${cpmToDisplay.toFixed(
              2
            )} (CPM)`}</Typography>
          }
          color="secondary"
          icon={<CurrencyDollar />}
          size="small"
        />
        {showWarning &&
          atleastOneChildSelected &&
          isAllCreativeTypeSection === false && (
            <Tooltip title={warningText} placement="top" arrow>
              <SemanticWarning color="warning" fontSize={24} />
            </Tooltip>
          )}
        <Tooltip
          title="This signifies the total cost of the segments within this specific category"
          placement="top"
          arrow
        >
          <InfoCircle fontSize={20} sx={{ textColor: 'neutral-400' }} />
        </Tooltip>
      </Box>
    )
  }
  return <span>{row.original.label}</span>
}
